import { NgModule } from '@angular/core';
import {
  BeneficiaireContextService,
  BeneficiaireStorageService,
  CeContextService,
  CeStorageService,
  ContextInitializerService,
  LocalStorageService,
  UserStorageService,
  AuthService,
  PlatformContextService
} from './services';
import { ArticleRepositoryService, ParamCeRepositoryService } from './services/repository/symfony-api';
import { PlatformContextDirective } from './directives/platform-context/platform-context';
import { DeliveryService } from './services/delivery.service';
import { LoadingService } from './services/loading.service';
import { EscapeDataPipe } from './pipes/keepData.pipe';
import {OrderService} from './services/order.service';
import {DossierPrestationsService} from './services/dossierPrestations.service';
import {Base64Parser} from './services/base64Parser.service';
import {CompteBancaireService} from './services/compteBancaire.service';
import {PushService} from './services/push.service';
import {ToolsService} from './services/tools.service';
import { ReducceService } from './services/reducce.service';
import { ReduccePaymentService } from './services/reducce-payment.service';
import { ReducceTopService } from './services/reducce-top.service';
import { SiteService } from './services/site.service';
import { SubventionService } from './services/subvention.service';
import { PaylineService } from './services/payline.service';
import {WebSliderService} from './services/webSlider.service';
import {BlogThemeService} from "./services/blogTheme.service";
import {EnvironnementService} from "./services/environnement.service";

@NgModule({
  exports: [
    PlatformContextDirective
  ],
  declarations: [
    PlatformContextDirective
  ],
  providers: [
    AuthService,
    PushService,
    ToolsService,

    LocalStorageService,
    BeneficiaireStorageService,
    UserStorageService,
    CeStorageService,

    BeneficiaireContextService,
    CeContextService,
    ContextInitializerService,
    PlatformContextService,
    OrderService,
    SubventionService,
    DossierPrestationsService,
    CompteBancaireService,
    Base64Parser,

    ArticleRepositoryService,
    ParamCeRepositoryService,
    DeliveryService,
    LoadingService,
    EscapeDataPipe,
    PaylineService,
    ReducceService,
    ReduccePaymentService,
    ReducceTopService,
    SiteService,
    WebSliderService,
    BlogThemeService,
    EnvironnementService
  ]
})
export class SharedModule {
}



// WEBPACK FOOTER //
// ./src/shared/shared.module.ts